/* eslint-disable import/order */
import React, { useEffect, useState } from "react";
import CardApplication from "components/CardApplication";
import styled from "styled-components";
import ApplicationEmpty from "./ApplicationEmpty";

const Card = styled.div`
  min-width: calc(width / 2);
`;
const Application = (props) => {
  const { activeId, setIsEmpty,finalData, loading, refresh} = props;
  const [isDataEmpty, setIsDataEmpty] = useState(false);
  // const onHandleDetail = (id) => {
  //   if (activeId === id) {
  //     handleDetail(false, "");
  //   } else {
  //     handleDetail(true, id);
  //   }
  // };

  useEffect(() => {
    setIsDataEmpty(!loading && finalData.length <= 0);
    setIsEmpty(!(!loading && finalData.length <= 0));
  }, [loading, finalData]);

  return (
    <div className="row g-3" style={{height:'100%'}}>
      {loading && <div>loading</div>}
      {isDataEmpty ? (
        <ApplicationEmpty />
      ) : (
        <>
          {finalData.map((val, i) => {
            return (
              <Card key={val._id} className={`col-md-12 ${i % 2 === 1 && ""}`}>
                <CardApplication
                  refresh={() => refresh}
                  // onClick={() => onHandleDetail(val._id)}
                  data={val}
                  active={activeId === val._id}
                />
              </Card>
            );
          })}
        </>
      )}
    </div>
  );
};

export default Application;
